import { TherapistLicenseResponseModel } from './therapist-license-response-model';
export class TherapistLicenseInfoModel {
  appUserInfoId: string;
  modifiedByUserInfoId: number;
  therapistLicenseInfo: TherapistLicenseResponseModel[];
}
